<template>
    <div class="policy" :class="[
        !policyLoading ? `policy--${policyStatusColor}` : null,
        { 'policy--expanded': showMoreDetails },
    ]">
        <Loading v-if="policyLoading" />
        <template v-else>
            <div class="row row--policy box box--default" :class="{ 'row--active': showMoreDetails }">

                <div class="row__data row__data--medium row__data--fixed"
                    :class="{ 'row__data--underline': canEditPolicy }">
                    <span v-if="canEditPolicy" @click="handleStatusPopup(policy.team_id)">
                        <transition name="fade" mode="in-out">
                            <PopupEditer v-if="showStatusPopup" @togglePopup="showStatusPopup = $event"
                                :items="policyStatuses" :selected="policyStatus" :label="'name'"
                                @submit="updatePolicyStatus($event)" ref="inputElement" />
                        </transition>
                        {{ policyStatus }}
                    </span>
                    <span v-else>
                        {{ policyStatus }}
                    </span>
                </div>

                <div class="row__data row__data--medium" :class="{ 'row__data--underline': canEditPolicy }">
                    <span v-if="canEditPolicy" @click="showPolicyNumberPopup = true">
                        <transition name="fade" mode="in-out">
                            <PopupEditer v-if="showPolicyNumberPopup" @togglePopup="showPolicyNumberPopup = $event"
                                :selected="policyNumber" @submit="updatePolicyNumber($event)" />
                        </transition>
                        {{ policyNumber }}
                    </span>
                    <span v-else>
                        {{ policyNumber }}
                    </span>
                </div>

                <div v-if="plateNumber" class="row__data row__data--medium"
                    :class="{ 'row__data--underline': canEditPolicy }">
                    <span @click="canEditPolicy ? (showPolicyPlateNrPopup = true) : null"
                        :style="{ cursor: canEditPolicy ? 'pointer' : 'default' }">
                        <transition name="fade" mode="in-out">
                            <PopupEditer v-if="showPolicyPlateNrPopup && canEditPolicy"
                                @togglePopup="showPolicyPlateNrPopup = $event" :selected="plateNumber"
                                @submit="updatePlateNumber($event)" />
                        </transition>

                        {{ plateNumber }}
                    </span>
                </div>

                <div class="row__data row__data--medium" v-else> ------</div>

                <div class="row__data row__data--medium">{{ createdAt }}</div>

                <div class="row__data row__data--medium" :class="{
                    'row__data--underline': canEditPolicy
                }">
                    <span @click="canEditPolicy ? (showSubmitDatePopup = true) : null"
                        :style="{ cursor: canEditPolicy ? 'pointer' : 'default' }">
                        <transition name="fade" mode="in-out">
                            <PopupEditer v-if="showSubmitDatePopup && canEditPolicy" :isDate="true"
                                @togglePopup="showSubmitDatePopup = $event" :selected="submitDate"
                                @submit="updateSubmitDate($event)" />
                        </transition>

                        {{ submitDate }}
                    </span>
                </div>

                <div class="row__data row__data--medium policy__company">
                    <span>{{ company }}</span>
                </div>
                <div class="row__data row__data--medium">
                    {{ branch }}
                </div>
                <div class="row__data row__data--medium row__data--underline agent-field">

                    <span v-if="canEditPolicy" @click="getAgents(policy.team_id); showAgentPopup = true">
                        <transition name="fade" mode="in-out">
                            <PopupEditer @click.stop v-if="showAgentPopup" @togglePopup="showAgentPopup = $event"
                                :type="'policyFirstAgent'" :items="agents" :selected="agent" :position="'left'"
                                :label="['first_name', 'last_name']" @submit="updatePolicyAgent($event)" />
                        </transition>
                        {{ agent }}
                    </span>

                    <span v-else>
                        {{ agent }}
                    </span>

                    <span v-if="policy.second_agent != null && canEditPolicy"
                        @click="openSecondAgentPopup">
                        <transition name="fade" mode="in-out">
                            <PopupEditer @click.stop v-if="showSecondAgentPopup"
                                @togglePopup="showSecondAgentPopup = $event" :type="'policySecondAgent'" :items="secondAgentOptions"
                                :selected="agent2" :secondarySelected="selectedSecondAgentCategoryId" :position="'left'"
                                :label="['first_name', 'last_name']" @submit="updateSecondPolicyAgent($event)"
                                @deleteSecondAgent="openDeleteSecondAgentModal" />
                        </transition>
                        {{ agent2 }}
                    </span>

                    <span v-else-if="policy.second_agent != null && !canEditPolicy">
                        {{ agent2 }}
                    </span>
                </div>

                <div class="row__data row__data--medium row__data--half row__data--last">
                    <div class="row__data row__data--small row__data--pdf icon icon__pdf"
                        :class="{ 'icon__pdf--active': policy.policy_files.length }" @click="openPolicyFilesModal()">
                    </div>
                    <div class="row__data row__data--small row__data--more"
                        :class="{ 'row__data--rotate': showMoreDetails }" @click="showMoreDetails = !showMoreDetails">
                    </div>
                </div>
            </div>
            <div class="policy__services" :class="{ 'policy__services--expand': showMoreDetails }">
                <div class="services" ref="servicesRef" :style="showMoreDetails
                    ? { maxHeight: `${servicesHeight}px` }
                    : { maxHeight: 0 }
                    " :class="{ 'services--expand': showMoreDetails }">
                    <div class="services__no-data" v-if="!services.length">
                        {{ $t(`policies.${"tableHead"}.${"noServicesMsg"}`) }}
                    </div>
                    <template v-else>
                        <div class="table__header table__header--inner">
                            <div class="table__label table__label--medium">
                                {{ $t(`policies.${"tableHead"}.${"insurance"}`) }}
                            </div>
                            <div class="table__label table__label--medium">
                                {{ $t(`policies.${"tableHead"}.${"contactStart"}`) }}
                            </div>
                            <div class="table__label table__label--medium">{{
                                $t(`policies.${"tableHead"}.${"contactEnd"}`) }}</div>
                            <div class="table__label table__label--medium">
                                {{ $t(`policies.${"tableHead"}.${"dueDate"}`) }}
                            </div>
                            <div class="table__label table__label--medium">
                                {{ $t(`policies.${"tableHead"}.${"caseWorker"}`) }}
                            </div>
                            <div class="table__label table__label--medium">{{
                                $t(`policies.${"tableHead"}.${"netPremium"}`) }}</div>
                            <div class="table__label table__label--medium">{{
                                $t(`policies.${"tableHead"}.${"grossPremium"}`) }}</div>
                            <div class="table__label table__label--medium">{{ $t(`policies.${"tableHead"}.${"payment"}`)
                                }}</div>
                            <div class="table__label table__label--medium services__label--delete"></div>
                            <div class="table__label table__label--medium services__label--delete"></div>
                        </div>
                        <PolicyService v-for="(service, index) in services" :key="service.id" :service="service"
                            :mandate="policy.mandate" :fetchGlobalCustomer="fetchGlobalCustomer"
                            :isLastService="index === services.length - 1" :totalNetto="policy.total_netto"
                            :totalBrutto="policy.total_bruto" :owner="policy.owner" :createdAt="policy.created_at" />
                    </template>
                </div>
            </div>
        </template>
    </div>
</template>

<script setup>
import { ref, computed, onMounted, nextTick, watch } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import statics from "@/statics";
import PolicyService from "@/components/AccountDetails/PolicyService";
import PopupEditer from "@/partials/PopupEditer";
import Loading from "@/partials/Loading";
import { formatDisplayDate } from "@/helpers/dateFormatters";
import { fetchGlobalCustomer } from "@/helpers/accountDetailHelpers";

defineOptions({
    name: "Policy"
});

const props = defineProps({
    policy: {
        required: true,
        type: Object,
    },
    expandedPolicyId: {
        type: Number,
        required: false,
    }
});

const store = useStore();
const route = useRoute();
const isSuperAdmin = computed(() => store.getters.isSuperAdmin);
const policyTeamId = computed(() => props.policy?.team_id
    ?? props.policy?.team?.id
    ?? props.policy?.customer?.team_id
    ?? props.policy?.customer?.team?.id
    ?? store.getters.customer?.team_id
    ?? store.getters.customer?.team?.id
    ?? null);
const canEditPolicy = computed(() => {
    if (isSuperAdmin.value) return true;
    return store.getters.hasTeamPermission("policy_edit", policyTeamId.value);
});

// State
const showMoreDetails = ref(false);
const showStatusPopup = ref(false);
const showAgentPopup = ref(false);
const showPolicyNumberPopup = ref(false);
const showPolicyPlateNrPopup = ref(false);
const showSubmitDatePopup = ref(false);
const showSecondAgentPopup = ref(false);
const policyLoading = ref(false);
const statusesArr = ref(null);
const servicesRef = ref(null);
const servicesHeight = ref(0);

// Lifecycle
onMounted(() => {
    if (props.policy.id == props.expandedPolicyId) {
        showMoreDetails.value = true;
    }
});

// Computed
const policyForms = computed(() => store.getters.policyForms);

const policyStatus = computed(() =>
    (props.policy?.policy_status?.name) ? props.policy.policy_status.name : statics.empty
);

const policyNumber = computed(() => props.policy.policy_number || statics.empty);
const plateNumber = computed(() => props.policy.plate_number || null);

const createdAt = computed(() =>
    props.policy.created_at ? formatDisplayDate(props.policy.created_at) : statics.empty
);

const submitDate = computed(() =>
    props.policy.submit_date ? formatDisplayDate(props.policy.submit_date) : statics.empty
);

const agent = computed(() =>
    props.policy.agent
        ? `${props.policy.agent.first_name || statics.empty} ${props.policy.agent.last_name || statics.empty}`
        : statics.empty
);

const agent2 = computed(() =>
    props.policy.second_agent
        ? `${props.policy.second_agent.first_name || statics.empty} ${props.policy.second_agent.last_name || statics.empty}`
        : statics.empty
);

const company = computed(() =>
    props.policy.company ? (props.policy.company.name || props.policy.company.full_name || statics.empty) : statics.empty
);

const branch = computed(() => {
    if (props.policy.policy_services.length) {
        return props.policy.policy_services[0].service.branch_category.name || statics.empty;
    }
    return null;
});

const services = computed(() =>
    props.policy.policy_services.length ? props.policy.policy_services : []
);

//const policyMandateService = computed(() => props.policy.mandate ? props.policy.mandate.service.code : null);

const policyStatusColor = computed(() => {
    if (props.policy.policy_status) {
        const status = statics.policyStatuses.find(s => props.policy.policy_status.id === s.id);
        return status ? status.name : null;
    }
    return null;
});

const policyStatuses = computed(() => statusesArr.value);
const agents = ref([]);
const secondAgentOptions = computed(() => {
    const primaryAgentId = props.policy?.agent?.id;

    if (!primaryAgentId) {
        return agents.value;
    }

    return agents.value.filter((agentItem) => Number(agentItem.id) !== Number(primaryAgentId));
});
const selectedSecondAgentCategoryId = computed(() => {
    return (
        props.policy?.secondAgentSalesCategory?.id ??
        props.policy?.second_agent_sales_category?.id ??
        null
    );
});

watch(
    [showMoreDetails, services],
    async () => {
        if (!showMoreDetails.value) {
            servicesHeight.value = 0;
            return;
        }

        await nextTick();
        servicesHeight.value = servicesRef.value?.scrollHeight || 0;
    },
    { immediate: true, deep: true }
);

// Methods
const handleStatusPopup = (teamId) => {
    getPolicyFormData(teamId);
    showStatusPopup.value = true;
};

const getPolicyFormData = async (id) => {
    await store.dispatch("getPolicyForms", id);
    statusesArr.value = policyForms.value["policy-statuses"];
};

const getAgents = async (teamId = props.policy.team_id) => {
    const resolvedTeamId = teamId ?? props.policy.team_id;
    if (!resolvedTeamId) {
        agents.value = [];
        return [];
    }

    const response = await store.dispatch("getTeamAgents", {
        teamId: resolvedTeamId,
        model: "policy_create",
    });

    const mappedAgents = Array.isArray(response?.agents)
        ? response.agents.map((agentItem) => ({
            ...agentItem,
            fullName: `${agentItem.first_name || ""} ${agentItem.last_name || ""}`.trim(),
        }))
        : [];

    agents.value = mappedAgents;
    return mappedAgents;
};

const updatePolicyStatus = async (policyStatusId) => {
    if (!canEditPolicy.value) return;

    policyLoading.value = true;
    await store.dispatch("updatePolicyStatus", {
        policyId: props.policy.id,
        policyStatusId,
    });
    await fetchGlobalCustomer(route.params.id);
    showStatusPopup.value = false;
    policyLoading.value = false;
};

const updatePolicyAgent = async (policyAgentId) => {
    if (!canEditPolicy.value) return;

    policyLoading.value = true;
    await store.dispatch("updatePolicyAgent", {
        policyId: props.policy.id,
        policyAgentId,
    });
    await fetchGlobalCustomer(route.params.id);
    showAgentPopup.value = false;
    showSecondAgentPopup.value = false;
    policyLoading.value = false;
};

const updateSecondPolicyAgent = async ({ second_agent_id, second_agent_sales_category_id }) => {
    if (!canEditPolicy.value) return;

    policyLoading.value = true;
    await store.dispatch("updateSecondPolicyAgent", {
        policyId: props.policy.id,
        secondAgentId: second_agent_id,
        secondAgentSalesCategoryId: second_agent_sales_category_id,
    });
    await fetchGlobalCustomer(route.params.id);
    showSecondAgentPopup.value = false;
    policyLoading.value = false;
};

const openDeleteSecondAgentModal = () => {
    if (!canEditPolicy.value) return;

    store.commit("setDeleteModal", {
        display: true,
        message: "Second Agent",
        action: async () => {
            policyLoading.value = true;
            await store.dispatch("deleteSecondPolicyAgent", {
                policyId: props.policy.id,
            });
            await fetchGlobalCustomer(route.params.id);
            showSecondAgentPopup.value = false;
            policyLoading.value = false;
        },
        id: props.policy.id,
        type: "delete",
    });
};

const updatePolicyNumber = async (policyNumber) => {
    if (!canEditPolicy.value) return;

    policyLoading.value = true;
    await store.dispatch("updatePolicyNumber", {
        policyId: props.policy.id,
        policyNumber,
    });
    await fetchGlobalCustomer(route.params.id);
    showPolicyNumberPopup.value = false;
    policyLoading.value = false;
};

const updatePlateNumber = async (plateNumber) => {
    if (!canEditPolicy.value) return;

    policyLoading.value = true;
    await store.dispatch("updatePlateNumber", {
        policyId: props.policy.id,
        plateNumber,
    });
    await fetchGlobalCustomer(route.params.id);
    showPolicyPlateNrPopup.value = false;
    policyLoading.value = false;
};

const updateSubmitDate = async (submitDate) => {
    if (!canEditPolicy.value) return;

    policyLoading.value = true;
    await store.dispatch("updateSubmitDate", {
        policyId: props.policy.id,
        submitDate,
    });
    await fetchGlobalCustomer(route.params.id);
    showSubmitDatePopup.value = false;
    policyLoading.value = false;
};

const openSecondAgentPopup = async () => {
    await getAgents(props.policy.team_id);
    showSecondAgentPopup.value = true;
};

const openPolicyFilesModal = () => {
    if (!store.getters.isSuperAdmin && !store.getters.hasTeamPermission("policy_access", policyTeamId.value)) return;

    store.commit("setPolicyFileId", props.policy.id);
    store.commit("setPolicyFiles", props.policy.policy_files);
    store.commit("setPolicyFilesModalIsTermination", false);
    store.commit("setShowPolicyFilesModal", true);
};
</script>

<style lang="scss" scoped>
.table {
    &__header {
        padding-left: 15px;
    }

    &__label {
        padding: 0;
        text-align: left;
    }
}

.agent-field {
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
    gap: 5px !important;
}
</style>
